import RandingStyle29 from "../../randing/RandingStyle29";

function Randing508({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle29
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      topCallIconImg={`${process.env.REACT_APP_CDN_BASE}/images/508/callButton.png`}
      callIconImg={`${process.env.REACT_APP_CDN_BASE}/images/508/02.gif`}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/508/01.jpg`}
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/508/postBtn.gif`}
      companyName="검단뉴욕치과의원"
      callNumber="0507-1381-8528"
    />
  );
}

export default Randing508;
